import { useQuery } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { getDashboardOverviewV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDashboardOverviewQuery = (enabled = true) => {
	return useQuery({
		queryKey: GoalsKeys.overview(),
		queryFn: processResponse(() => getDashboardOverviewV2()),
		enabled,
	});
};
